module.exports = __webpack_public_path__ + "media/images/menu/globular_clusters-92f49a51d1c640ce752d2387679f0b75.jpg";